import React, { memo } from 'react'
import Layout from '@/components/Layout/Layout'
import styles from './index.module.css'

const Notfound: React.FC = memo(() => (
  <Layout>
    <div className={styles.container}>
      <h1 className={styles.h1}>404: Page Not Found</h1>
    </div>
  </Layout>
))
Notfound.displayName = 'Notfound'

export default Notfound
